<template>
  <div class="pages">
    <div class="content" v-html="content"></div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      content: ''
    }
  },
  mounted() {
    document.title = '中船航海人才招聘'
    this.loadData()
  },
  methods: {
    loadData() {
      let that = this
      that.$api.publicConfig({
        key: 'employ_company',
      }).then(res => {
        that.content = res.data.value
      })
    }
  }
}
</script>
<style scoped src="./company.css"></style>
      